export enum StrategyLineType {
  PREFERRED = 'PREFERRED',
  AVOID = 'AVOID',
}
